"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Th;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react2 = require("@chakra-ui/react");

var _Context = require("./Context");

var _jsxRuntime = require("react/jsx-runtime");

// deps
// contexts
function Th(props) {
  const {
    children,
    ...otherProps
  } = props;
  const {
    layout
  } = (0, _Context.useTable)();
  const hidden = "column" === layout;
  const styleProps = hidden ? {
    border: "0rem",
    clip: "rect(0rem, 0rem, 0rem, 0rem)",
    height: "0.0625rem",
    width: "0.0625rem",
    margin: "-0.0625rem",
    padding: "0rem",
    overflow: "hidden",
    whiteSpace: "nowrap",
    position: "absolute"
  } : {};
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react2.Th, { ...otherProps,
    ...styleProps,
    children: children
  });
}

Th.propTypes = {
  children: _propTypes.default.node
};